// extracted by mini-css-extract-plugin
export default {"container":"LanguageSelector_container__Cj-ih","flag":"LanguageSelector_flag__J+27A","active":"LanguageSelector_active__3R3Nu"};